import styled from "styled-components";
import ContainerInfo from "./ContainerInfo";

import { formatarData } from "../../Funcoes/FormatarData"
import { formatCPF } from "../../Funcoes/FormatCPF"

const Container = styled.div`
    width: 520px;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 10px;
    overflow: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE e Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari */
    }
`
const MainContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
`
const PicContainer = styled.div`
    width: 225px;
    aspect-ratio: 3 / 4;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    & img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

`
const TextsContainer = styled.div`
    width: calc( 100% - 225px );
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const SecondContainer = styled.div`
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px; /* mantém espaçamento como no TextsContainer */
`

const Informacoes = ({ data }) => {
    return (
        <>
            <Container>
                <MainContainer>
                    <PicContainer>
                        <img src={data?.IMAGEM} alt="Foto 3x4 do colaborador" />
                    </PicContainer>
                    <TextsContainer>
                        <ContainerInfo title="MATRÍCULA" value={data?.MATRICULA || '-'} />
                        <ContainerInfo title="NOME" value={data?.NOME || '-'} />
                        <ContainerInfo title="CPF" value={data?.CPF ? formatCPF(data.CPF) : "-"} />
                        <ContainerInfo title="CENTRO DE CUSTO" value={data?.CENTRO_CUSTO || '-'} />
                        <ContainerInfo title="FUNÇÃO" value={data?.FUNCAO || '-'} />
                        <ContainerInfo title="SITUAÇÃO" value={data?.STATUS || '-'} />
                    </TextsContainer>
                </MainContainer>
                <SecondContainer>
                    <ContainerInfo title="DATA DE ADMISSÃO" value={data?.ADMISSAO ? formatarData(data.ADMISSAO) : "-"} />
                    <ContainerInfo title="DATA DE DEMISSÃO" value={data?.DEMISSAO ? formatarData(data.DEMISSAO) : "-"} />
                    <ContainerInfo title="MÃO DE OBRA" value={data?.MAO_OBRA || '-'} />
                    <ContainerInfo title="SEXO" value={data?.SEXO || '-'} />
                    <ContainerInfo title="DATA DE NASCIMENTO" value={data?.DATA_NASC ? formatarData( data.DATA_NASC ) : '-'} />
                    <ContainerInfo title="RG" value={data?.RG || '-'} />
                    <ContainerInfo title="UF DO RG" value={data?.RG_UF || '-'} />
                    <ContainerInfo title="MUNICÍPIO DE RESIDÊNCIA" value={ `${ data?.MUNICIPIO }/${ data?.ESTADO }` || '-'} />
                    <ContainerInfo title="PIS" value={data?.PIS || '-'} />
                    <ContainerInfo title="CONTATO" value={
                        data?.TELEFONE
                            ? `${data?.DDDFONE ? `(${data.DDDFONE}) ` : ""}${data.TELEFONE}`
                            : "-"
                    } />
                </SecondContainer>
            </Container>
        </>
    )
}

export default Informacoes;